module.exports = __webpack_public_path__ + "d6bb288bfa7f4180d3b530c115974917.MP3";